import { styled, TextField, type TextFieldProps } from '@mui/material';

type AutocompleteTextFieldProps = Omit<TextFieldProps, 'variant'>;

export const AutocompleteTextField = styled(
  (props: AutocompleteTextFieldProps) => (
    <TextField
      variant="standard"
      {...props}
      InputProps={{
        disableUnderline: true,
        ...props.InputProps,
      }}
      InputLabelProps={{
        shrink: true,
        ...props.InputLabelProps,
      }}
    />
  )
)({
  '&& .MuiInputBase-root': {
    height: 32,
    marginTop: 0,
    position: 'relative',
    padding: '5.585px 8px 5.585px 8px',
    borderRadius: 4,
    border: '1px solid #828D98',
    fontSize: 13,
    backgroundColor: '#fff',

    '&.Mui-focused': {
      outline: '2px solid #0175C9',
      outlineOffset: '2px',
      borderRadius: 4,
      backroundColor: 'unset',
    },

    '&.Mui-disabled': {
      backgroundColor: '#F9F9FA',
      borderColor: '#D8DBDF',
    },

    '& .MuiInputBase-input.Mui-disabled': {
      WebkitTextFillColor: '#B1B8BF',
    },

    '&.Mui-readOnly': {
      borderColor: 'transparent',
      backgroundColor: '#F9F9FA',
    },

    '&.Mui-error': {
      borderColor: '#D82C0D',
    },

    '& ::placeholder': {
      color: '#828D98',
      opacity: 1,
    },
  },

  '& .MuiInputLabel-root': {
    position: 'static',
    height: 20,
    marginBottom: 4,
    transform: 'none',
    fontSize: 13,
    fontWeight: 700,
    color: '#292D35',
    '& .MuiFormLabel-asterisk': {
      color: '#D82C0D',
      fontWeight: 500,
    },
    '&.Mui-disabled': {
      color: '#292D35',
    },
    '& .Mui-focused': {
      color: '#292D35',
    },
    '&.Mui-error': {
      color: '#292D35',
    },
  },

  '& .MuiFormHelperText-root': {
    height: 20,
    marginLeft: 0,
    fontSize: 13,
    color: '#63717E',

    '& .Mui-error': {
      color: '#D82C0D',
    },
  },
});
